import { render } from "./popup.vue?vue&type=template&id=ab8c25e8&scoped=true"
import script from "./popup.vue?vue&type=script&lang=js"
export * from "./popup.vue?vue&type=script&lang=js"

import "./popup.vue?vue&type=style&index=0&id=ab8c25e8&scoped=true&lang=css"

import exportComponent from "/tmp/build_b726cccb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab8c25e8"]])

export default __exports__